var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ruleBox"},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"}),_c('div',{staticClass:"ruleBox-rule",domProps:{"innerHTML":_vm._s(_vm.ruleData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }